import PropTypes from 'prop-types';

export const includedItems = PropTypes.shape({
  orderUuid: PropTypes.string.isRequired,
  orderTaskUuid: PropTypes.string.isRequired,
  orderTaskType: PropTypes.string.isRequired,
  orderTaskStatus: PropTypes.string.isRequired,
  orderTaskJurisdiction: PropTypes.string.isRequired,
  orderItemUuid: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  createdDatetime: PropTypes.string.isRequired,
});

export const orderRow = PropTypes.shape({
  amount: PropTypes.string,
  category: PropTypes.string,
  paymentDate: PropTypes.string,
  paymentStatus: PropTypes.string,
  included: PropTypes.arrayOf(includedItems),
  isTransactional: PropTypes.bool,
  orderUuid: PropTypes.string,
  orderTaskUuid: PropTypes.string.isRequired,
  orderTaskType: PropTypes.string.isRequired,
  orderTaskStatus: PropTypes.string.isRequired,
  orderTaskJurisdiction: PropTypes.string.isRequired,
  orderItemUuid: PropTypes.string.isRequired,
  displayName: PropTypes.string.isRequired,
  createdDatetime: PropTypes.string.isRequired,
});
